import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';
import { useStyles } from './styles';

const Props = {
  textTitle: PropTypes.node.isRequired,
  textDescription: PropTypes.node.isRequired,
  textButton: PropTypes.string.isRequired,
};

export default function CustomLandingPageMobile({ textTitle, textDescription, textButton }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" pt={4} pb={2}>
        <Container>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Box>
              <Typography component="h2" className={classes.title}>
                <b>{textTitle}</b>
              </Typography>

              <Box py={2} px={2}>
                <Typography className={classes.textDescription} variant="body1" component="p">
                  {textDescription}
                </Typography>
              </Box>
            </Box>

            <img
              src="/images/institutions/create-landing-page.gif"
              alt="create landing page gif"
              loading="lazy"
              width={344}
              height={180}
            />

            <Box py={2}>
              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>{textButton}</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}

CustomLandingPageMobile.propTypes = Props;
